const APIv4GetCustomerInfoResponseAdapter = {
  toGetCustomerInfoResponse: v4Response => {
    const {
      response_data
    } = v4Response;
    return new V4Customer(response_data);
  }
};
export default APIv4GetCustomerInfoResponseAdapter;
export class V4Customer {
  constructor(v4ResponseData) {
    this.v4ResponseData = v4ResponseData;
  }
  get type() {
    return this.v4ResponseData.type;
  }
  get email() {
    return this.v4ResponseData.email;
  }
  get firstName() {
    return this.v4ResponseData.info.firstname;
  }
  get lastName() {
    return this.v4ResponseData.info.lastName;
  }
  get userName() {
    return this.v4ResponseData.username;
  }
  get country() {
    return this.v4ResponseData.info.country;
  }
  get birthday() {
    return this.v4ResponseData.info.birthday;
  }
  get monthOfBirth() {
    return this.v4ResponseData.info.birthday;
  }
  get yearOfBirth() {
    return this.v4ResponseData.info.birthday;
  }
  get genre() {
    return this.v4ResponseData.genre || null;
  }
  get newsletter() {
    return this.v4ResponseData.subscribe_newsletter;
  }
  get promotions() {
    return this.v4ResponseData.subscribe_promotion;
  }
  get addresses() {
    return this.v4ResponseData.info.address;
  }
}
